var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.isAnchor ? "a" : "li",
    {
      tag: "component",
      staticClass: "ui-menu-option",
      class: _vm.classes,
      style: _vm.activeStyle,
      attrs: {
        "supports-modality": "keyboard",
        role: "menu-item",
        href: _vm.isAnchor ? (_vm.disabled ? null : _vm.href) : null,
        tabindex: _vm.isDivider || _vm.isAnchor || _vm.disabled ? null : "0",
        target: _vm.isAnchor ? (_vm.disabled ? null : _vm.target) : null,
      },
      on: {
        focus: function ($event) {
          _vm.isActive = true
        },
        blur: function ($event) {
          _vm.isActive = false
        },
      },
    },
    [
      !_vm.isDivider
        ? _vm._t("default", function () {
            return [
              _c(
                "div",
                { staticClass: "ui-menu-option-content" },
                [
                  _vm.icon
                    ? _c("KIcon", {
                        staticClass: "k-icon",
                        attrs: { icon: _vm.icon },
                      })
                    : _vm._e(),
                  _c("div", { staticClass: "ui-menu-option-text" }, [
                    _vm._v("\n        " + _vm._s(_vm.label) + "\n      "),
                  ]),
                  _vm.secondaryText
                    ? _c(
                        "div",
                        { staticClass: "ui-menu-option-secondary-text" },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.secondaryText) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }